import React from 'react'
import {UniLink} from '../unilink/index'
import './breadCrumbs.css'

export function getBreadcrumbsFromTopic(topic) {
  let breadcrumbTopics = []
  if (topic.depth > 2) {
    breadcrumbTopics.push(topic.parent)
    if (topic.parent.depth > 2) {
      let tempTopic = topic.parent
      while (tempTopic.depth > 2) {
        tempTopic = tempTopic.parent
      }
      if (tempTopic.id !== topic.parent.id) {
        breadcrumbTopics = [tempTopic, topic.parent]
      }
    }
  }
  return breadcrumbTopics
}

const generateBreadcrumbs = (breadcrumbTopics, noLink) => {
  if (breadcrumbTopics.length) {
    if (noLink) {
      return breadcrumbTopics
        .map((topic)=>(
          <span key={topic.id} to={topic.slug} dangerouslySetInnerHTML={{__html:topic.renderedTitle}} />
        ))
    } else {
      return breadcrumbTopics
        .map((topic, index)=>(
          <UniLink key={topic.id} to={topic.slug} dangerouslySetInnerHTML={{__html:topic.renderedTitle}} />
        ))
    }

  } else {
    return ''
  }
}

const BreadCrumbs = ({className, breadcrumbTopics, noLink}) => {
  const classNames = ['breadcrumbs', className]
  return (
    <span className={classNames.join(' ')}>{generateBreadcrumbs(breadcrumbTopics, noLink)}</span>
  )
}

export default BreadCrumbs



// WEBPACK FOOTER //
// ./src/core/components/breadcrumbs/BreadCrumbs.js